/**
 * Character limit helpers for description/text fields.
 * Kept separate to avoid circular deps (description schema uses this; fieldSchemas re-exports).
 */

import type { FieldSchemaConfig } from '../types';

/** Default max length for description fields when column does not set maxChar. */
export const defaultDescriptionMaxChar = 500;

/**
 * Effective character limit for this column, if any.
 * - description: col.maxChar ?? defaultDescriptionMaxChar
 * - text: col.maxChar ?? null
 * - other types: null
 */
export function getCharacterLimit(col: FieldSchemaConfig): number | null {
  const type = col.type ?? 'text';
  const explicit = col.maxChar != null && col.maxChar > 0 ? col.maxChar : null;
  if (type === 'description') return explicit ?? defaultDescriptionMaxChar;
  return explicit;
}
